<template>
  <div style="width: 100%; background-color: #333333">
    <div style="width: 980px; margin: 0px auto">
<div v-if="numPages!=1">
      <el-button-group style="    margin: 10px;">
        <el-button type="primary" icon="el-icon-arrow-left" @click="prev" style="margin-right:10px">上一页</el-button>
        <el-button type="primary" @click="next"
          >下一页<i class="el-icon-arrow-right el-icon--right" ></i
        ></el-button>
      </el-button-group>
      <el-tag> {{cur}} / {{numPages}} 页</el-tag> 
</div>
      <div style="page-break-after: always">
        <pdf :src="url" :page="cur" @page-loaded="cur = $event" @num-pages="numPages = $event" />
      </div>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  name: "PdfView",
  components: {
    pdf,
  },
  data() {
    return {
      url: "",
      numPages: undefined,
      cur:undefined,
 
    };
  },
  created() {
    let pdfFile = this.$route.query.pdfFile;
    this.url = pdf.createLoadingTask(pdfFile, { withCredentials: false });
  },
  mounted() {
    this.url.promise
      .then((d) => {
        this.numPages = d.numPages;
        this.cur = 1;
        console.log(this.cur)
      })
      .catch((r) => {
        console.log(r);
      });
  },

  methods: {
    prev(){
      const cur = this.cur;
      if(cur <= 1){
        this.cur = 1;
      }else{
        this.cur = cur - 1
      }
      console.log(this.cur)
    },
    next(){
      const cur = this.cur;
      if(cur >= this.numPages){
        this.cur = this.numPages;
      }else{
        this.cur = cur + 1
      }
      console.log(this.cur)
    }
  },
};
</script>